import { useContext } from 'react';
import { ILoadingContext, LoadingContext } from '../../providers/LoadingProvider';

export default function useLoading(): ILoadingContext {
  return useContext(LoadingContext);
}
